import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import {UsePaginationInstanceProps, UsePaginationState} from "react-table";

/**
 * Pagination für das Listing der zuvor getätigten Einreichungen
 *
 * @param canPreviousPage
 * @param canNextPage
 * @param pageCount
 * @param gotoPage
 * @param nextPage
 * @param previousPage
 * @param pageIndex
 * @constructor
 */
const ReactTablePagination = (
    {
        canPreviousPage,
        canNextPage,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        pageIndex
    }: UsePaginationInstanceProps<any> & UsePaginationState<any>
) => {
    /**
     * Rendert die nummerischen Buttons der Pagination, über welche direkt auf eine Seite gesprungen werden kann
     */
    const renderNumberedPages: () => JSX.Element[] = () => {
        const pageButtons: JSX.Element[] = [];
        for (let i = 0; i < pageCount; i++) {
            pageButtons.push(
                <Button key={'page-index-' + i} onClick={() => gotoPage(i)}
                        className={i === pageIndex ? 'btn button-selected' : 'btn btn-light'}>
                    {i + 1}
                </Button>
            );
        }

        return (pageButtons);
    }

    return (
        <Container className='paperSubmissionPagination'>
            <Row className='justify-content-center'>
                <Col xs='auto' className='text-center'>
                    <Button key={'page-index-first'} onClick={() => gotoPage(0)} disabled={!canPreviousPage}
                            className=''>
                        {'«'}
                    </Button>
                    <Button key={'page-index-prev'} onClick={() => previousPage()} disabled={!canPreviousPage}
                            className=''>
                        {'‹'}
                    </Button>
                    {renderNumberedPages()}
                    <Button key={'page-index-next'} onClick={() => nextPage()} disabled={!canNextPage}
                            className=''>
                        {'›'}
                    </Button>
                    <Button key={'page-index-last'} onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}
                            className=''>
                        {'»'}
                    </Button>
                </Col>
            </Row>
        </Container>
    );
}

export default ReactTablePagination;
